import { Box, SimpleGrid } from '@chakra-ui/react';

import Pagination from '@/components/ui/Pagination/Pagination';
import { TAgent, TAgentResponse } from '@/types/agents';

import AgentCard from '../AgentCard/AgentCard';
import AgentsEmptyState from '../AgentsEmptyState/AgentsEmptyState';
import AgentsSkeleton from '../AgentsSkeleton/AgentsSkeleton';

interface AgentsMainContentProps {
  agentsData: TAgentResponse;
  page: number;
  setPage: (page: number) => void;
  isLoading: boolean;
  onAgentClick: (agent: TAgent) => void;
}

const AgentsMainContent = ({
  agentsData,
  page,
  setPage,
  isLoading,
  onAgentClick,
}: AgentsMainContentProps) => {
  const agents = agentsData?.items || [];

  if (isLoading) {
    return <AgentsSkeleton />;
  }

  if (agents.length === 0) {
    return <AgentsEmptyState />;
  }

  return (
    <Box>
      <SimpleGrid columns={{ base: 2, sm: 2, md: 3, lg: 3 }} gap={4} mb={10}>
        {agents.map((agent) => (
          <AgentCard key={agent.referenceId} agent={agent} onOpenDetails={() => onAgentClick(agent)} />
        ))}
      </SimpleGrid>
      <Pagination
        totalPages={agentsData?.pagination.totalPages || 1}
        pageSize={9}
        page={page}
        onPageChange={setPage}
      />
    </Box>
  );
};

export default AgentsMainContent;
